import React from 'react';
import PropTypes from 'prop-types';

import { omit } from 'lodash';
import displayName from 'component-lib/displayName';

import styles from '../Datepicker.scss';

export default function WeekdayBox(props) {
    const widgetProps = omit(props, [
        'styles',
        'styleName',
    ]);

    return (
        <div
            className={styles['weekday-box']}
            {...widgetProps}
        >
            {props.text}
        </div>
    );
}

WeekdayBox.displayName = displayName('Widgets/Datepicker/WeekdayBox');

WeekdayBox.propTypes = {
    text: PropTypes.string.isRequired,
};
